import type { BrandConfig } from '@vantage-hub/brand-kit'
import { ApiClientProvider } from '@vantage-hub/api-client'
import { I18nProvider } from '@vantage-hub/i18n'
import { Skeleton } from '@vantage-hub/ui'
import type { ReactNode } from 'react'

interface ProvidersProps {
  config: BrandConfig
  children: ReactNode
}

export function Providers({ config, children }: ProvidersProps) {
  return (
    <I18nProvider config={config.i18n} fallback={<Skeleton className="h-screen w-full" />}>
      <ApiClientProvider config={config.api}>
        {children}
      </ApiClientProvider>
    </I18nProvider>
  )
}
